import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import { FormikProps, getIn } from "formik";
import CustomTextArea from "../../../../../../../../../components/CustomTextArea";
import Flex from "../../../../../../../../../components/Flex";
import Text from "../../../../../../../../../components/Text";
import { Form2Payload } from "../../../../../../scheduling/appointment/encounter/encounter-constant";

// Checkbox + reveal-on-check note list. Fields live nested under `notePath`:
// key = boolean flag, `${key}Note` = its free-text note.
interface CbtCheckboxNoteListProps {
  formik: FormikProps<Form2Payload>;
  items: readonly { key: string; label: string }[];
  notePath?: string;
  noteLabel?: string;
  columns?: number;
  compact?: boolean;
}

const CbtCheckboxNoteList = ({
  formik,
  items,
  notePath = "psychotherapyCbtVisitNote",
  noteLabel = "Note",
  columns = 1,
  compact = false,
}: CbtCheckboxNoteListProps) => {
  const md = Math.max(1, Math.floor(12 / columns));
  return (
    <Grid container spacing={compact ? 0.8 : 1} width="100%">
      {items.map((it) => {
        const fieldKey = `${notePath}.${it.key}`;
        const noteKey = `${notePath}.${it.key}Note`;
        const checked = !!getIn(formik.values, fieldKey);
        return (
          <Grid item xs={12} sm={columns > 1 ? 6 : 12} md={md} key={it.key}>
            <Flex flexDirection="column" gap={0.5} width="100%">
              <FormControlLabel
                sx={compact ? { mb: 0.2 } : undefined}
                control={
                  <Checkbox
                    size={compact ? "small" : "medium"}
                    sx={compact ? { py: 0.25 } : undefined}
                    name={fieldKey}
                    checked={checked}
                    onChange={(e) =>
                      formik.setFieldValue(fieldKey, e.target.checked)
                    }
                  />
                }
                label={
                  <Text variant={compact ? "body2" : undefined}>
                    {it.label}
                  </Text>
                }
              />
              {checked && (
                <CustomTextArea
                  label={noteLabel}
                  rows={2}
                  name={noteKey}
                  placeholder={noteLabel}
                  value={getIn(formik.values, noteKey) ?? ""}
                  onChange={(e) =>
                    formik.setFieldValue(noteKey, e.target.value)
                  }
                />
              )}
            </Flex>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default CbtCheckboxNoteList;
